module.exports = __webpack_public_path__ + "img/limited-time-award-2.ef8224a3.png";